// extracted by mini-css-extract-plugin
module.exports = {"styledNameCell":"dhrpzu4t","numberCell":"CcPJVx9A","surpriseCell":"f9WGgZzT","surpriseCellPositive":"Swu9mEkv","surpriseCellZero":"V9dy41ES"};